import FBody from '@/plugins/form/FBody';
import FDate from  '@/plugins/form/FDate1'
import FInput from  '@/plugins/form/FInput'

import FDictionaryCity from '../../../../Dictionary/City/Select';
import FDictionaryManager from '../../../../Dictionary/Manager/Select';
 import FDictionaryPartner from '../../../../Dictionary/Partner/Select';
import FDictionaryCountry from "../../../../Dictionary/Country/Select";
import FDictionaryDepartment from "../../../../Dictionary/Department/Select";
import FDictionaryAgreementStatus from "../../../../Dictionary/AgreementStatus/Select";

export default class extends FBody {
  country = new FDictionaryCountry({
    label: 'Страна',
    clearable: true,
    showAdd: false,
  });

  city = new FDictionaryCity({
    label: 'Город',
    clearable: true,
    country: this.country,
    showAdd: false,
  });

  nameTour = new FInput({
    label: 'Название тура',
    clearable: true,
  });
  fioTourist = new FInput({
    label: 'ФИО туриста',
  });
  numberAgreement = new FInput({
    label: 'Номер Путевки',
  });
  priceForTourist = new FInput({
    label: 'Цена для туриста',
  });
  priceForAgency = new FInput({
    label: 'Цена для агенства',
  });
  price = new FInput({
    label: 'Себестоимость',
  });
  payedForAgreement = new FInput({
    label: 'Оплачено за путевку',
  });
  debtForAgreement = new FInput({
    label: 'Долг за путевку',
  });
  statusAgreement = new FDictionaryAgreementStatus({
    label: 'Статус',
    clearable: true,
  });

  partner = new FDictionaryPartner({
    label: 'Агенство',
    clearable: true,
    isMyAgency: true,
  });
  department = new FDictionaryDepartment({
    label: 'Офис',
    clearable: true,
  });
  manager = new FDictionaryManager({
    label: 'Менеджер',
    clearable: true,
  });
  dateCreate = new FDate({
    label: 'Дата создания',
    clearable: true,
    picker: true,
  });

  dateStart = new FDate({
    label: 'Дата начала поездки',
    clearable: true,
    picker: true,
  });
  dateEnd = new FDate({
    label: 'Дата окончания поезки',
    clearable: true,
    picker: true,
  });

  days = new FInput({
    label: 'Дней',
    clearable: true,
  });

  constructor(props) {
    super(props);
    this.setItems([
      ['country', this.country],
      ['city', this.city],
      ['nameTour', this.nameTour],
      ['fioTourist', this.fioTourist],
      ['numberAgreement', this.numberAgreement],
      ['priceForTourist', this.priceForTourist],
      ['priceForAgency', this.priceForAgency],
      ['price', this.price],
      ['payedForAgreement', this.payedForAgreement],
      ['debtForAgreement', this.debtForAgreement],
      ['statusAgreement', this.statusAgreement],
      ['partner', this.partner],
      ['department', this.department],
      ['manager', this.manager],
      ['dateCreate', this.dateCreate],
      ['dateStart', this.dateStart],
      ['dateEnd', this.dateEnd],
      ['days', this.days],
    ]);
  }

  get data() {
    const data = super.data;
    return {
      CountryId: data.country || null,
      CodeAgreement: data.numberAgreement,
      CityIds: data.city || null,
      NameTour: data.nameTour || null,
      FioTourist: data.fioTourist || null,
      PriceForTourist: data.priceForTourist || null,
      PriceForAgency: data.priceForAgency || null,
      Price: data.price || null,
      PayedForAgreement: data.payedForAgreement || null,
      DebtForAgreement: data.debtForAgreement || null,
      StatusAgreementId: data.statusAgreement || null,
      PartnerId: data.partner || null,
      DepartmentId: data.department || null,
      ManagerId: data.manager || null,
      'DateCreate.Serialized': data.dateCreate,
      'DateStart.Serialized': data.dateStart,
      'DateEnd.Serialized': data.dateEnd,
      Days: data.days,
    };
  }

  set data(data) {
    // data = data || {};
    // this.departure.set(data.DepartureId ? {
    //   value: data.DepartureId,
    // } : null);
    // this.city.set({
    //   value: data.CityIds?.[0] ? data.CityIds[0] : null,
    // });
    // this.type.set(data.TourTypeId ? {
    //   value: data.TourTypeId,
    // } : null);
    // this.partner.set(data.PartnerId ? {
    //   value: data.PartnerId,
    // } : null);
    // this.tour.set(data.TourId ? {
    //   value: data.TourId,
    // } : null);
    // this.duration.set({
    //   from: data.FromDuration || 1,
    //   to: data.ToDuration || 1,
    // });
    // this.dates.setString({
    //   from: data['FromDate.Serialized'] || '',
    //   to: data['ToDate.Serialized'] || '',
    // });
  }

  init() {
    return super.init();
  }

  init(data) {
    if(data!=undefined){
      this.dateStart.set(data.date1);
      this.dateEnd.set(data.date2);
      this.nameTour.set(data.name);
    }
    return super.init();
  }
}
